export const useLangLink = (lang) => {
  if (lang === 'en') {
    return ''
  } else {
    return '/' + lang
  }
}

export default useLangLink